import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import { LayoutBase } from './layout-base'
import { mapNavigationMenuProps } from '../../data-mappers/organims/navigation-menu.mapper'
import { mapFooterProps } from '../../data-mappers/organims/footer.mapper'

type LayoutEnProps = {
  children: React.ReactElement[]
}

export const LayoutEn = ({ children }: LayoutEnProps) => {
  const data = useStaticQuery(graphql`
    query LayoutEnQuery {
      cms {
        navigation(locale: "en") {
          ...navigationMenuFragment
        }
        footer(locale: "en") {
          ...footerFragment
        }
      }
    }
  `)

  const {
    cms: { navigation, footer },
  } = data

  return (
    <>
      <LayoutBase menu={mapNavigationMenuProps(navigation)} footer={mapFooterProps(footer)}>
        {children}
      </LayoutBase>
    </>
  )
}
